/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifie le type de filtre de liste utilisé par la props `typeListe`
 * de PacsListeContainer
 */
// eslint-disable-next-line no-shadow
enum TypeListePacs {
  PacsProjet = 1, // renvoie les projets de pacs
  PacsEnCours = 2, // renvoie les conclusion de pacs en cours
  PacsDissous = 3, // renvoie les pacs dissous
  PacsIrrecevable = 4, // renvoie les pacs irrecevable
  ToutPacs = 5, // renvoie les 4 types précédents
}

export default TypeListePacs;
